import React, { memo } from 'react';
import { Image } from 'react-native';
import { rem } from 'design-system/values';
const source = require('design-system/img/emma-plan-pro.png');
const PlanEmmaPro = ({ size = rem(48) }) => (<Image source={source} style={{ width: size, height: size }}/>);
export default memo(PlanEmmaPro);
